import { ProcessingTypeSortOption } from '@rematter/frontend-lib-api-client';

import { ProcessingTypeRecord } from '../types/processingType';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const processingTypesQueryAtom = createQueryAtomFactory(
  'production.processingTypes',
  (params: {
    searchTerm?: string;
    isActive?: boolean;
    limit?: number;
    offset?: number;
    sorting?: ProcessingTypeSortOption[];
  }) => ({
    processingTypes: {
      __args: {
        filter: {
          searchTerm: params.searchTerm,
          isActive: params.isActive,
        },
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 25,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        name: true,
        code: true,
        description: true,
        isActive: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
        inputItems: {
          id: true,
          itemId: true,
          isPrimary: true,
          sortOrder: true,
          notes: true,
        },
        outputItems: {
          id: true,
          itemId: true,
          outputUnit: true,
          yieldPercentage: true,
          isPrimary: true,
          isNoCost: true,
          costAllocationPercentage: true,
          sortOrder: true,
          notes: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (
      data,
    ): {
      processingTypes: ProcessingTypeRecord[];
      totalCount: number;
    } => {
      if (!data?.processingTypes?.entries) {
        return {
          processingTypes: [],
          totalCount: 0,
        };
      }

      return {
        processingTypes: data.processingTypes.entries.map((pt) => ({
          id: pt.id,
          name: pt.name,
          code: pt.code,
          description: pt.description ?? undefined,
          isActive: pt.isActive,
          createdAt: pt.timestamps.createdAt,
          updatedAt: pt.timestamps.updatedAt,
          inputItems: pt.inputItems?.map((item) => ({
            id: item.id,
            itemId: item.itemId,
            isPrimary: item.isPrimary,
            sortOrder: item.sortOrder,
            notes: item.notes,
          })),
          outputItems: pt.outputItems?.map((item) => ({
            id: item.id,
            itemId: item.itemId,
            outputUnit: item.outputUnit,
            yieldPercentage: item.yieldPercentage,
            isPrimary: item.isPrimary,
            isNoCost: item.isNoCost,
            costAllocationPercentage: item.costAllocationPercentage,
            sortOrder: item.sortOrder,
            notes: item.notes,
          })),
        })),
        totalCount: data.processingTypes.page?.total ?? 0,
      };
    },
  },
);
